import { Component, EventEmitter, HostBinding, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { takeUntil } from 'rxjs/operators';
import { AuditReportDownloadPopupComponent } from 'src/app/audit/audit-report-download-popup/audit-report-download-popup.component';
import { User } from 'src/app/shared/models/auth/user.model';
import { Company } from 'src/app/shared/models/company.model';
import { ApiResponse } from 'src/app/shared/models/api.response';
import { GlobalService } from 'src/app/shared/services/global.service';
import { ApplicationNameService } from 'src/app/shared/services/application-name.service';
import { SnackbarService } from 'src/app/shared/services/snackBarService.service';
import { ThemeService } from 'src/app/shared/services/theme.service';
import { CompanyApiService } from 'src/app/company/services/company-api.service';
import { BaseComponent } from 'src/app/core/base-classes/base/base.component';

@Component({
    selector: 'fury-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ToolbarComponent extends BaseComponent implements OnInit {

  @Input()
  @HostBinding('class.no-box-shadow')
  public hasNavigation: boolean;

  @Output() public openSidenav = new EventEmitter();
  @Output() public openQuickPanel = new EventEmitter();

  public user: User;
  public company: Company;
  public isHomeRoute: boolean = false;
  public auditReportFilterSetting: boolean = false;
  public topNavigation$ = this._themeService.config$.pipe(map(config => config.navigation === 'top'));

  constructor(
    private _themeService: ThemeService,
    private _globalService: GlobalService,
    public applicationNameService: ApplicationNameService,
    private _dialog: MatDialog,
    private _router: Router,
    private _companyService: CompanyApiService,
    private _snackbarService: SnackbarService
  ) {
    super();
    this.user = this._globalService.user;
    this.company = this._globalService.company;
  }

  ngOnInit() {
    this.checkRoute();
    this._router.events
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.checkRoute();
      });
  }

  checkRoute(): void {
    this.isHomeRoute = this._router.url === '/';
    this.auditReportFilterSetting = this._globalService.company.auditReportFilter;
  }

  get isAdmin(): boolean {
    return this.user?.userType === 'Admin';
  }

  get canShowReportDownload(): boolean {
    return this.isHomeRoute && this.auditReportFilterSetting && this.isAdmin;
  }

  openReportDownloadDialog(): void {
    this._dialog.open(AuditReportDownloadPopupComponent, {
      width: '520px',
      maxWidth: '95vw',
      maxHeight: '90vh',
    }).afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((result: { startDate: string; endDate: string; emails: string[] }) => {
        if (result) {
          let req = {
            companyId: this.company.id,
            startDate: result.startDate,
            endDate: result.endDate,
            emailList: result.emails,
          }
          this._companyService.generateCompanyAuditReport(req)
            .pipe(takeUntil(this.destroy$))
            .subscribe((res: ApiResponse<unknown>) => {
              this._snackbarService.open(res.message, 'Close', 'success');
            });
        }
      });
  }

}
